import { laptopMaxXL, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 7px 7px 7px 15px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.backgroundLight};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  & > p {
    flex: 1;
    text-align: left;
    font-weight: bold;
    font-size: 18px;
  }

  @media (${laptopMaxXL}) {
    flex-direction: row;

    & > p {
      text-align: left;
    }
  }

  @media (${tabletMax}) {
    padding: 12px;
    flex-direction: column;

    & > p {
      text-align: center;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 260px;
  width: 100%;
  gap: 15px;

  a {
    flex: 1;
  }
`;
